/**
 * @file Scroll to top component for handling scroll restoration on route navigation.
 */

import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends Component {
  static propTypes = {
    location: PropTypes.object,
    children: PropTypes.oneOf([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
  };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (window && window.scrollTo) {
        window.scrollTo(0, 0);
      }
    }
  }

  render() {
    return this.props.children || null;
  }
}

export default withRouter(ScrollToTop);
